import NumberFormat from 'react-number-format';
import styled, { css, keyframes } from 'styled-components';
import ReactSelect from 'react-select';

export const Container = styled.div``;

export const Header = styled.div`
  margin: 10px 30px 50px 30px;
  display: flex;
  justify-content: space-between;
`;

export const AreaSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    font-size: 14px;
    margin-left: 8px;
  }
`;
export const ButtonsArea = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100px;
  width: 95%;
  position: fixed;
  bottom: 0px;
  padding-right: 25px;

  padding-top: 20px;

  border-top: 1px solid #c4c4c4;
  background: #fff;

  @media (max-width: 1300px) {
    bottom: 0px;
  }
`;
export const StockBanner = styled.div`
  width: 100%;
  background: #ecfffd;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 15px;
  padding: 20px;

  margin-top: 10px;

  p {
    text-align: left;
    font-size: 20px;
    color: #414141;
    font-weight: bold;
  }

  span {
    font-size: 18px;
    color: #414141;
  }

  img {
    margin-right: 20px;
  }
`;
export const NumberFormatStyledValue = styled.input`
  height: 44px;
  width: 70%;

  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  text-align: center;
  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;

export const InputStyled = styled.input`
  width: 60%;
  height: 44px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};

  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;

export const ButtonAdd = styled.button`
  color: #ff2c3a;
  text-decoration: underline;
  border: none;
  font-weight: bold;
  background-color: transparent;
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const ErrorContainer = styled.div`
  width: 60%;
  min-width: 600px;
  margin: 10px auto 30px auto;

  background: orange;
  color: #fff;

  border-radius: 8px;
  padding: 30px;

  p {
    text-align: center;
    font-size: 22px;
  }
`;

export const SelectStyled = styled(ReactSelect)`
  width: 90%;
  text-align: left;
`;

export const InputsTable = styled.table`
  width: 100%;
  border-collapse: initial;
  border-spacing: 0 30px;
  background: ${(props) => props.theme.colors.white};

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid transparent;
    }
    td:last-child {
      text-align: right;
    }
    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;
export const InnerArea = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 729px;
  max-height: 720px;

  padding: 20px 20px 220px;

  @media (max-width: 1281px) {
    padding: 20px 20px 420px;
    max-height: 584px;
    height: 584px;
    margin-bottom: 420px;
  }

  @media (min-width: 1282px) and (max-width: 1450px) {
    padding: 20px 20px 420px;
    max-height: 620px;
    height: 620px;
  }

  ${(props) =>
    props.browserZoomLevel > 100 &&
    css`
      padding: 20px 20px 720px;
    `}
`;

export const NumberFormatStyled = styled(NumberFormat)`
  height: 44px;
  width: calc(100% - 54px);
  max-width: 120px;
  min-width: 82px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  text-align: center;
  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;

export const CmvButtons = styled.div`
  display: flex;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  cursor: pointer;

  input {
    margin-right: 5px;
  }
`;

export const SubmitStyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  margin-left: 8px;
  background-color: #0ccab4;
  svg {
    color: #fff;
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.lightGray};
    svg {
      filter: opacity(0.3);
      color: #333;
    }
  }
`;

export const PersonalizedHoursContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 10px 0px;
  flex-wrap: wrap;
`;

const pulseGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(12, 202, 180, 0.45);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 12px rgba(12, 202, 180, 0);
    transform: scale(1.06);
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const AiLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  gap: 20px;
`;

export const AiLoadingIconWrapper = styled.div`
  width: 68px;
  height: 68px;
  background: linear-gradient(135deg, #0ccab4, #018ccc);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${pulseGlow} 1.8s ease-in-out infinite;
`;

export const AiLoadingInnerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AiLoadingText = styled.div`
  text-align: center;
  p {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
  }
  span {
    font-size: 12px;
    color: #888;
  }
`;

export const AiFiscalBanner = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #eafaf8, #e8f4ff);
  border: 1.5px solid #0ccab4;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const AiFiscalBannerLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const AiFiscalBannerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AiFiscalBannerIconWrap = styled.div`
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #0ccab4, #018ccc);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const AiFiscalBannerTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #0a8c7e;
  line-height: 1.3;
`;

export const AiFiscalBannerSub = styled.span`
  font-size: 12px;
  color: #545454;
  font-weight: 500;
`;

export const AiFiscalPrompt = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #f8fdfc, #f5faff);
  border: 2px dashed #0ccab4;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: ${props => props.$isLoading ? 'default' : 'pointer'};
  transition: all 0.3s ease;
  opacity: ${props => props.$isLoading ? '0.9' : '1'};

  &:hover {
    background: ${props => props.$isLoading 
      ? 'linear-gradient(135deg, #f8fdfc, #f5faff)' 
      : 'linear-gradient(135deg, #eafaf8, #e8f4ff)'};
    border-color: ${props => props.$isLoading ? '#0ccab4' : '#018ccc'};
    transform: ${props => props.$isLoading ? 'none' : 'translateY(-2px)'};
    box-shadow: ${props => props.$isLoading ? 'none' : '0 4px 12px rgba(12, 202, 180, 0.15)'};
  }

  &:active {
    transform: ${props => props.$isLoading ? 'none' : 'translateY(0)'};
  }
`;

export const AiFiscalPromptLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const AiFiscalPromptIconWrap = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0ccab4, #018ccc);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(12, 202, 180, 0.3);
  
  ${props => props.$isLoading && css`
    animation: ${rotate} 2s linear infinite;
  `}

  svg {
    ${props => props.$isLoading && css`
      animation: ${pulseGlow} 1.5s ease-in-out infinite;
    `}
  }
`;

export const AiFiscalPromptContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const AiFiscalPromptTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #0a8c7e;
  line-height: 1.3;
`;

export const AiFiscalPromptDescription = styled.span`
  font-size: 12px;
  color: #666;
  font-weight: 400;
  line-height: 1.4;
`;

export const AiFiscalPromptButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #fff;
  border: 1.5px solid #0ccab4;
  border-radius: 8px;
  flex-shrink: 0;
  transition: all 0.2s ease;

  span {
    font-size: 13px;
    font-weight: 600;
    color: #0ccab4;
  }

  ${AiFiscalPrompt}:hover & {
    background: #0ccab4;
    border-color: #0ccab4;

    span {
      color: #fff;
    }

    svg {
      color: #fff !important;
    }
  }
`;
